module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "file-drop"
  }, [_c('div', {
    staticClass: "file-label",
    class: _vm.fileUpload.class
  }, [_vm._v(_vm._s(_vm.fileUpload.msg))]), _vm._v(" "), _c('div', {
    staticClass: "prog-bar",
    class: {
      'prog-transition': _vm.fileUpload.transitionClass
    },
    style: ({
      width: _vm.fileUpload.progress + '%'
    })
  }), _vm._v(" "), _c('fileupload', {
    staticClass: "input-file",
    attrs: {
      "target": _vm.fileUpload.target,
      "action": "POST",
      "accept": ".jpg, .jpeg, .png"
    },
    on: {
      "start": _vm.startUpload,
      "finish": _vm.finishUpload,
      "progress": _vm.uploadProgress
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6357c53a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadField.vue
// module id = 294
// module chunks = 0